import React from 'react';
import DragAndDropItemWrapper from "Components/Common/components/DragAndDrop/DragAndDropItemWrapper"
import { TimesIcon } from "assests/GmsIcons"
import { DraggableProvided, DraggableRubric, DraggableStateSnapshot } from "@hello-pangea/dnd"
import { ThandleRemove } from "types/Components/Common/Table/TableHeaderControlModal"
import { TTableHeader } from "types/Components/Common/Table/Table"

/* Local copy of GmsIcons' GripIcon on currentColor — the shared one hardcodes
   fill/stroke #707275 so it cannot theme, and editing it would repaint its other
   consumer (ISR ComponentLibrary). Dots unchanged. */
const GripGlyph = () => (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" aria-hidden="true">
        <path d="M1.875 8.875C2.35825 8.875 2.75 8.48325 2.75 8C2.75 7.51675 2.35825 7.125 1.875 7.125C1.39175 7.125 1 7.51675 1 8C1 8.48325 1.39175 8.875 1.875 8.875Z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.125 8.875C7.60825 8.875 8 8.48325 8 8C8 7.51675 7.60825 7.125 7.125 7.125C6.64175 7.125 6.25 7.51675 6.25 8C6.25 8.48325 6.64175 8.875 7.125 8.875Z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.875 2.75C2.35825 2.75 2.75 2.35825 2.75 1.875C2.75 1.39175 2.35825 1 1.875 1C1.39175 1 1 1.39175 1 1.875C1 2.35825 1.39175 2.75 1.875 2.75Z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.125 2.75C7.60825 2.75 8 2.35825 8 1.875C8 1.39175 7.60825 1 7.125 1C6.64175 1 6.25 1.39175 6.25 1.875C6.25 2.35825 6.64175 2.75 7.125 2.75Z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.875 15C2.35825 15 2.75 14.6082 2.75 14.125C2.75 13.6418 2.35825 13.25 1.875 13.25C1.39175 13.25 1 13.6418 1 14.125C1 14.6082 1.39175 15 1.875 15Z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.125 15C7.60825 15 8 14.6082 8 14.125C8 13.6418 7.60825 13.25 7.125 13.25C6.64175 13.25 6.25 13.6418 6.25 14.125C6.25 14.6082 6.64175 15 7.125 15Z" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

/**
 * Header contol modal dragable item
 *
 * @param items - all the items to render
 * @param handleRemove - remove button handler
 * @returns
 */
const DragAndDropHeaderItem = (items: TTableHeader[], handleRemove: ThandleRemove) => (className?: string) => (provided: DraggableProvided, snapshot: DraggableStateSnapshot, rubric: DraggableRubric) => (
    <DragAndDropItemWrapper provided={provided}>
         <div className={`!tw-cursor-move tw-flex tw-items-center tw-justify-between tw-bg-surface-sunken tw-text-ink tw-p-1.5 tw-px-2.5 tw-rounded tw-w-[inherit] ${className}`}>
             <div className={`tw-flex tw-items-center tw-space-x-3`}>
                 <span className={`tw-text-ink-tertiary`}>
                     <GripGlyph/>
                 </span>
                 <span>
                     <p className={`tw-leading-5 tw-pointer-events-none tw-max-w-[220px] tw-truncate`}>{items[rubric.source.index].name}</p>
                 </span>
             </div>
             <div className={`tw-p-1 hover:tw-bg-tone-neutral-tint tw-rounded-sm tw-group tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-cursor-pointer`}>
                 <button aria-label="Close" data-testid="components-draganddropheaderitem-button-1" onClick={(e) => handleRemove(e, rubric.source.index)} type="button" className={`tw-hidden group-hover:tw-block`}>
                     <span className={`tw-border !tw-border-edge-strong tw-rounded-sm tw-flex tw-items-center tw-justify-center tw-text-ink-secondary tw-h-[13.5px] tw-w-[13.5px] `}>
                         <TimesIcon/>
                     </span>
                 </button>
             </div>
         </div>
     </DragAndDropItemWrapper>
 )

 export default DragAndDropHeaderItem